webpackJsonp([0],[
/* 0 */
/* no static exports found */
/* all exports used */
/*!**************************!*\
  !*** ./example/index.js ***!
  \**************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(/*! ./App */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ }),
/* 1 */
/* exports provided: default */
/* exports used: default */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json2mq__ = __webpack_require__(/*! json2mq */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json2mq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_json2mq__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'media',
  props: {
    query: {
      type: [Object, String],
      required: true
    },
    visibleByDefault: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      matches: this.visibleByDefault
    };
  },

  methods: {
    updateMatches: function updateMatches() {
      this.matches = this.mediaQueryList.matches;
    }
  },
  mounted: function mounted() {
    var query = this.query,
        matches = this.matches;

    if (typeof window === 'undefined') {
      return matches;
    }
    var mediaQuery = __WEBPACK_IMPORTED_MODULE_0_json2mq___default()(query);
    this.mediaQueryList = window.matchMedia(mediaQuery);
    this.updateMatches();
    this.mediaQueryList.addListener(this.updateMatches);
  },
  render: function render() {
    if (this.matches) {
      return this.$slots.default[0];
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.mediaQueryList) {
      this.mediaQueryList.removeListener(this.updateMatches);
    }
  },

  watch: {
    matches: function matches(newMatch) {
      if (this.mediaQueryList) {
        newMatch ? this.$emit('media-enter', this.mediaQueryList.media) : this.$emit('media-leave', this.mediaQueryList.media);
      }
    }
  }
});

/***/ }),
/* 2 */
/* exports provided: default */
/* all exports used */
/*!******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./~/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/egoist/dev/vue-media/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./example/App.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************/
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src__ = __webpack_require__(/*! ../src */ 1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Media: __WEBPACK_IMPORTED_MODULE_0__src__["a" /* default */]
  },
  data: function data() {
    return {
      msg: ''
    };
  },

  methods: {
    maxWidth800: function maxWidth800() {
      this.msg = 'smaller than 800';
    },
    maxWidth800Leave: function maxWidth800Leave(media) {
      console.log('Has left media: ', media);
    },
    minWidth800: function minWidth800() {
      this.msg = 'bigger than 800';
    },
    minWidth800Leave: function minWidth800Leave(media) {
      console.log('Has left media: ', media);
    }
  }
});

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/* no static exports found */
/* exports used: default */
/*!*************************!*\
  !*** ./example/App.vue ***!
  \*************************/
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../~/vue-loader/lib/component-normalizer */ 6)(
  /* script */
  __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/egoist/dev/vue-media/~/babel-preset-vue-app/dist/index.common.js",{"useBuiltIns":true}]]}!../~/vue-loader/lib/selector?type=script&index=0!./App.vue */ 2),
  /* template */
  __webpack_require__(/*! !../~/vue-loader/lib/template-compiler/index?{"id":"data-v-0ab08fe8"}!../~/vue-loader/lib/selector?type=template&index=0!./App.vue */ 7),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */,
/* 7 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************************************!*\
  !*** ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ab08fe8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/App.vue ***!
  \********************************************************************************************************************************************/
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h1', [_vm._v("Resize the window to see the effect:")]), _vm._v(" "), _c('media', {
    attrs: {
      "query": {
        maxWidth: 800
      }
    },
    on: {
      "media-enter": _vm.maxWidth800,
      "media-leave": _vm.maxWidth800Leave
    }
  }, [_c('div', [_c('h2', {
    staticStyle: {
      "color": "orange"
    }
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h3', [_vm._v("horay!")])])]), _vm._v(" "), _c('media', {
    attrs: {
      "query": {
        minWidth: 800
      }
    },
    on: {
      "media-enter": _vm.minWidth800,
      "media-leave": _vm.minWidth800Leave
    }
  }, [_c('div', [_c('h2', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h3', [_vm._v("oops!")])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/* no static exports found */
/* all exports used */
/*!********************************!*\
  !*** multi ./example/index.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/egoist/dev/vue-media/example/index.js */0);


/***/ })
],[10]);


// WEBPACK FOOTER //
// client.3994a3f2.js